module.exports = "/assets/data/2979c0a957be3e0480f88c4ef893994d-WS1.data.json";